import React from "react";
import EvaluateTask from "./components/EvaluateTask";
import ReviewInvoices from "./components/ReviewInvoices";
import ReviewInspection from "./components/ReviewInspection";
import RefundProcess from "./components/RefundProcess";
import GoThroughSteps from "./components/GoThroughSteps";
import SDWaiver from "./components/SDWaiver";
import MailDisposition from "./components/MailDisposition";
import Information from "./components/Information";
import FAQLinks from "./components/FAQLinks";

const SDRefundContent = ({ itemId, listId, checkedItems }) => {
  return (
    <div>
      {itemId === 1 && (
        <EvaluateTask
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <ReviewInvoices
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <ReviewInspection
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 4 && (
        <RefundProcess
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 5 && (
        <GoThroughSteps
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <SDWaiver itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
      {itemId === 7 && (
        <MailDisposition
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 8 && (
        <Information
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 9 && (
        <FAQLinks itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
    </div>
  );
};

export default SDRefundContent;
